import { render, staticRenderFns } from "./offline_activity_edit.vue?vue&type=template&id=99bf08dc&scoped=true"
import script from "./offline_activity_edit.vue?vue&type=script&lang=js"
export * from "./offline_activity_edit.vue?vue&type=script&lang=js"
import style0 from "./offline_activity_edit.vue?vue&type=style&index=0&id=99bf08dc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bf08dc",
  null
  
)

export default component.exports